module.exports = __webpack_public_path__ + "static/media/users_white.cb08e37a.png";